import Noty from 'noty';

const defaults = {
    layout: 'topRight',
    theme: 'bootstrap-v4',
    timeout: 5000,
    progressBar: false,
    closeWith: ['button'],
};

const Notifications = {

    options: {},

    setOptions(options) {
        this.options = Object.assign({}, defaults, options);

        return this;
    },

    createButtons(buttons = []) {
        return buttons.map(button => {
            return Noty.button(button.text, button.classes, button.callback, button.attributes || {});
        });
    },

    show(text, type = 'info', buttons = [], options = {}) {
        const params = Object.assign({}, this.options, options, {
            type,
            text,
            buttons: this.createButtons(buttons)
        });

        const noty = new Noty(params);

        noty.show();

        return noty;
    },

    success(text, buttons = [], options = {}) {
        return this.show(text, 'success', buttons, options)
    },

    error(text, buttons = [], options = {}) {
        return this.show(text, 'error', buttons, options)
    },

    warning(text, buttons = [], options = {}) {
        return this.show(text, 'warning', buttons, options)
    },

    info(text, buttons = [], options = {}) {
        return this.show(text, 'info', buttons, options)
    },

    button(text, classNames, callback, options = {}) {
        return Noty.button(text, classNames, callback, options);
    }

};

export default {
    install: (Vue, options) => {
        const notifications = Notifications.setOptions(options);
        Vue.prototype.$notifications = notifications;
        Vue.notifications = notifications;
    }
};